import { createElement } from "react"
import { ReactNode } from "react-markdown/lib/react-markdown"

interface Props {
  level: number
  className?: string
  children: ReactNode
}

export const Heading = (props: Props) => {
  const { level, className, children } = props
  return createElement(`h${level}`, { className }, children)
}
